import * as actionTypes from "../consts/actionTypes";

/**acciones que se disparan del componente */
export function postContactUs(param) {
  return {
    type: actionTypes.POST_CONTACT_US,
    payload: param,
  };
}